// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__2ZqaK","checkbox":"Item_checkbox__3PHSW","blocks":"Item_blocks__2Ih2V","block":"Item_block__2W06k","label":"Item_label__1xTii"};